/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import React, { forwardRef } from 'react'
import TopLoadingBar from 'react-top-loading-bar'

const LoadingBar = (props, ref) => {
  return <TopLoadingBar {...props} color="#f57328" ref={ref} />
}

LoadingBar.propTypes = {}
LoadingBar.defaultProps = {}

export default forwardRef(LoadingBar)
